import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { QuotationsVersion } from '../Quotations.contracts';
import { QuotationsVersionModule } from './Quotations.abstract';
import { ArticleAuthor } from '../../_components/ArticleAuthor';
import { ReactionsCount } from '../../_components/ReactionsCount';
import { BootstrapImage, BootstrapLink } from '../../../dsl/bootstrap';
import { ImageRatio } from '../../_contracts';
import { prepareImage } from '../../_filters';
let Editorial = class Editorial extends QuotationsVersionModule {
    getThumbnail(background) {
        if (!background) {
            return {
                src: '',
                width: null,
                height: null
            };
        }
        const ratio = ImageRatio.Original;
        const maxWidth = 280;
        return prepareImage(background, ratio, maxWidth, this.isLazy);
    }
};
Editorial.moduleVersion = QuotationsVersion.Editorial;
Editorial = __decorate([
    Component({
        name: 'Editorial',
        components: { ArticleAuthor, ReactionsCount, BootstrapLink, BootstrapImage },
        template: `
    <div v-show="active" class="quotations__list__wrap">
      <button class="quotations__list__arrow quotations__list__arrow--prev" :class="{ '--visible': isPrevVisible }" @click="goPrev">
        <D24Icon name="chevron-left" size="small" />
      </button>

      <div class="quotations__list quotations__list--editorial" :class="{ '--is-dragged': isDragged }" ref="container">
        <div v-for="item in items" :key="item.id" class="quotations__list__item">
          <BootstrapImage
            class="quotations__list__item__bg"
            src=""
            v-bind="{ ...getThumbnail(item.background), fallback: fallbackImage }"
          />

          <div class="quotations__list__item__text" v-html="demarkedContent(item)" />

          <ArticleAuthor
            v-if="item.author"
            class="quotations__list__item__author"
            :showPublicationDate="false"
            :author="item.author"
            :showAuthorName="true"
            :showAuthorAvatar="true"
          >
            <ReactionsCount :comments="item.article?.commentsCount" :likes="item.article?.reactionsCount?.like" />
          </ArticleAuthor>

          <BootstrapLink :link="{ target: item.article?.urlPath }" class="stretched-link" draggable="false" />
        </div>
      </div>

      <button class="quotations__list__arrow quotations__list__arrow--next" :class="{ '--visible': isNextVisible }" @click="goNext">
        <D24Icon name="chevron-right" size="small" />
      </button>
    </div>
  `
    })
], Editorial);
export { Editorial };
